<template>
  <div class="slider-pagination" :class="paginationClasses">
    <button v-for="index in slidesCount"
            :key="index"
            class="slider-pagination__dot"
            :class="{ 'slider-pagination__dot--active': index - 1 === currentIndex }"
            @click="$emit('slide-change', index - 1)"
            :aria-label="`Go to slide ${index}`" />
  </div>
</template>

<script>
export default {
  props: {
    slidesCount: {
      type: Number,
      required: true,
      validator: (value) => value >= 0
    },
    currentIndex: {
      type: Number,
      required: true,
      validator: (value) => value >= 0
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: (value) => ['horizontal', 'vertical'].includes(value)
    }
  },
  computed: {
    paginationClasses() {
      return {
        'slider-pagination--horizontal': this.orientation === 'horizontal',
        'slider-pagination--vertical': this.orientation === 'vertical'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.slider-pagination {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  z-index: 1;

  &--horizontal {
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    gap: 8px;
  }

  &--vertical {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    flex-direction: column;
    gap: 8px;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 9999px;
    border: none;
    background-color: #FB923C;
    padding: 0;
    transition: background-color 300ms ease-in-out;
    cursor: pointer;
    opacity: 0.3;

    &--active {
      opacity: 1;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
